import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div className="coming-soon-section">
      <div className="coming-soon-text">
        <h2>Be sure to check back with me! the blog is coming soon...</h2>
      </div>
    </div>
  );
};

export default Blog;
